import React from "react";
import "../index.css";
import FormsTable from "./FormsTable";

export default function LandingPage({
  handleProductSelection,
  products,
  nextStep,
}) {
  return (
    <>
      <div className="">
        <div className="flex flex-wrap text-center justify-center pt-16">
          <div className="w-full lg:w-6/12 px-4">
            <h2 className="text-4xl text-[#005b95]">Welcome to Print-only Agreements for New South Wales!</h2>
            <h3 className="mt-4 text-2xl">Purchase a single-use PDF agreement to download, print and complete by hand. These agreements cannot be edited, completed or signed online.</h3>
            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
              This tool allows you to create the form or agreement of your choice, for immediate download and printing. We only sell Bidders Registration cards in hardcopy from the <a href="https://reinsw.com.au/Web/Web/Store/Store.aspx" target="_blank" rel="noreferrer" className="text-blue-600 underline">Store</a>. All other forms are no longer available in printed packs.
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
              <strong className="font-medium">Please note:</strong> you are required to <strong className="font-medium">add the property address</strong> to the form/agreement before you can purchase and download. The address needed is the address of the property you are selling/managing and not your address.
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
              The exception to this is the SA00050 (Statement of Property Details and Buyers Agency Agreement), in this instance you are required to enter your <strong className="font-medium">Client's name and location</strong> (for example, John Smith, Northern Beaches NSW)
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
              This address/client's name and location will be populated in the address field of the form/agreement and then <strong className="font-medium">watermarked across each page</strong>. This address/client's name and location, will not be able to be changed once you have completed the purchase process and this field cannot be left blank.  If you notice a mistake after purchase, please contact us.
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
            Once the purchase process has been completed, the Forms/Agreement will be emailed to the nominated email address to be downloaded. The link to download will expire in seven (7) days. Once received,<strong className="font-medium"> you will then need to print the Form/Agreements and complete the remainder in wet ink (pen)</strong>.
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
              <strong className="font-medium">REMINDER: You will not be able to edit or add any details once completed.</strong>
            </p>

            <p className="text-lg text-left leading-relaxed mt-4 mb-4">
            While these Forms/Agreements are compliant with legislation we strongly recommend using a {" "} 
            <a className="text-blue-600 underline" href="https://www.reinsw.com.au/Web/Web/Find_an_Agent/Find_an_Agent_Landing_Page.aspx" rel="noreferrer" target="_blank">Licenced Real Estate Agent</a> {" "} 
             to manage all your real estate needs. If you are an agent using these forms and agreements, we recommend you use our <a className="text-blue-600 underline" href="https://www.reinsw.com.au/Web/Web/Store/REI_Forms_Live.aspx" rel="noreferrer" target="_blank">REI Forms Live</a> product.
            </p>
          </div>
        </div>

        <FormsTable
          navigateTo={nextStep}
          handleProductSelection={handleProductSelection}
          products={products}
        >
          Select a form below to proceed
        </FormsTable>
      </div>
    </>
  );
}
